const apiHostUrl = 'https://us-central1-smart-flip-app-dev.cloudfunctions.net';

export const environment = {
  production: false,
  logLevel: 'warn',
  faro: {
    enabled: true,
    url: 'https://faro-collector-prod-us-east-2.grafana.net/collect/80f8e98dbad62652b924871503490cb6',
    app: {
      name: 'SmartFlipAppDev',
      environment: 'development',
    },
  },
  firebase: {
    apiKey: 'AIzaSyB1s_rnSdTScsxm8Bp29_-JH1SOVOsyucU',
    authDomain: 'smart-flip-app-dev.firebaseapp.com',
    projectId: 'smart-flip-app-dev',
    storageBucket: 'smart-flip-app-dev.appspot.com',
    messagingSenderId: '83350129555',
    appId: '1:83350129555:web:b053ecdfa54671997f7666',
    measurementId: 'G-Q2TYH61WB7',
  },
  download: {
    functionUrl: `${apiHostUrl}/downloadPDF`,
    hostUrl: 'smart-flip-app-dev.web.app',
  },
  sentry: {
    dsn: 'https://1c7486624f993e5209b280cec4c29e29@o4506808376360960.ingest.us.sentry.io/4508383238946816',
  },
  googleApiKey: 'AIzaSyBJtoUd2vaGsB-eNSrhxqwlnrwr5wVuM8Y',
  apiHostUrl,
  attomApiKey: '9cf99bd797404c2f6d6e5fac040f17f1',
  attomApiUrlV1: 'https://api.gateway.attomdata.com/propertyapi/v1.0.0/',
  attomApiUrlV2: 'https://api.gateway.attomdata.com/property/v2/',
  stripePublishableKey:
    'pk_test_51N2iduDm8a3KnFeiLPyK4FMnQ5dundTnmc4EmAB4w2oRhhIj9XAU27uEiikI8yc049Je276Fznx9iwdz7r2l05ou00tgzri2mA',
  datafinitiKey:
    'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIzdmJxbjJ6ajJucG5yYnVmeWkzeThtajVyZWYwOXlseCIsImlzcyI6ImRhdGFmaW5pdGkuY28ifQ.A2ufHHap0ZAqV75WIk78EJNpAHUwGaOStsQkuqIbzsWXsgO-CyX97YhBmn2znevkzEKfeqyQ_Lp1T4B1V58Lhafjb3KQEECRXMlWzwtWS3fJsrDcuHT-V611pYoTx8WYp5QFENPjJxUcqnKHDQEastooXT01iQB5DJCKIbizmjjCi5hIaK-_D-8WvyHCrYB5aRmRCS_Yrf27fELzsGY42uCG0lzTwnmu7uWVqZeW8BK3J3rJEBpyYQJD-1j02NGjhJYQ6DjckbrbfjCb_Z2Jysi3GWibaNQSO9qJN_tRyMLSQatawYUtCoFH4a0T1uxikSOt5Pi-SxZkQlkNnhaIw4BR5y5zu7cGYy-DvgZJ7vHAS8dyMyKEThC4Z2ZhuMnNqbHJtgEk075tB17M0eEsa4O6ijSlozwDccPp0sX3Psan0emAJWzeM288bgT-Zcw-FyM7Rbsn4A2dR0ThgS8NXwRnZiR3-C6C9D4Na50bV-EbR43FFx2muiPUrSX2xN8A-RspIICcauo4Vwxi02WK3ACTSD2Mq3HrqcFXV8DLnXMalS_RRALQoGDCSHlpOK4oWkgU-UQ8K2ZcoCvOnXqvb_Os22gDosXA1apL7pCygxFWP1Sa4sg1VC6zXSGfF_eivmkUEAkue3aJ8kDV2gyM-LUA6WAl2wTQpjFp5DyK0Nw',
};
